document.addEventListener("DOMContentLoaded", function () {
    const phoneInputs = document.querySelectorAll('input[name="contact[Număr de telefon]"]');

    const getInputNumbersValue = function (input) {
        // Return stripped input value вЂ” just numbers
        return input.value.replace(/\D/g, '');
    }

    const onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData('Text');
            if (/\D/g.test(pastedText)) {
                // Attempt to paste non-numeric symbol вЂ” remove all non-numeric symbols,
                // formatting will be in onPhoneInput handler
                input.value = inputNumbersValue;
                return;
            }
        }
    }

    const onPhoneInput = function (e) {
        let input = e.target;
        input.value = getInputNumbersValue(input).substring(0, 14);
    };
    const onPhoneKeyDown = function (e) {
        // Clear input after remove last symbol
        let inputValue = e.target.value.replace(/\D/g, '');
        if (e.keyCode == 8 && inputValue.length == 1) {
            e.target.value = "";
        }
    }
    for (const phoneInput of phoneInputs) {
        phoneInput.addEventListener('keydown', onPhoneKeyDown);
        phoneInput.addEventListener('input', onPhoneInput, false);
        phoneInput.addEventListener('paste', onPhonePaste, false);
    }
})